module.exports = __webpack_public_path__ + "static/media/php.eea4bc58.svg";